export const mapCheckPoints = (values: Array<CheckpointType>): Array<CheckpointType> => {
  return values.map((item) => ({
    ...item,
    length: parseInt(item.length as any),
    radius: item.radius ? parseInt(item.radius as any) : 50,
  }));
};
